var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "sidebarFilter" },
    [
      _c("p", { staticClass: "sidebarFilter__desc" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.trans("FORM_SEARCH_REGION_FOCUS_DESCRIPTION")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("CustomSearchDropdown", {
        attrs: {
          id: "inlineDropdown__regionalBoost",
          "data-gtm": "sidebarFilter__regionalBoost",
          default: _vm.filterOptions[0],
          value: _vm.filterOption,
          disabled: _vm.disableRegionalBoost,
          options: _vm.filterOptions,
          element: "sidebarFilter__regionalBoost",
          bordered: true,
        },
        on: { changeValue: _vm.selectRegionalBoost },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }